import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
@Component({
})
export default class BarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>;
  @Prop({ default: () => ([]) }) readonly dataValue: any;
  @Prop({ default: null }) index: number
  @Prop({ default: 1 }) searchType: Number // 对比关系：1：设备对比，2：时间对比
  color = ['#37A2DA','#32C5E9','#67E0E3','#9FE6B8','#FFDB5C','#ff9f7f','#fb7293','#E062AE','#E690D1','#e7bcf3','#9d96f5','#8378EA','#96BFFF']
  standardEfficiency = null

  mounted() {
    this.init()
  }

  seriesDataItem(obj, standardEfficiency){
    const data = []
    let temp
    if (this.searchType === 1) {
      temp = Object.keys(obj).sort()
    } else {
      temp = Object.keys(obj).sort((a, b) => {
        return parseFloat(a) - parseFloat(b)
      })
    }
    temp.forEach((key)=> {
      let value = obj[key] * 100
      if (this.searchType===1 && standardEfficiency && value < standardEfficiency) {
        // 低于工位维护时候设置的标准效率则展示红色
        data.push(
          {
            value: value.toFixed(2),
            itemStyle: {
              color: '#a90000'
            },
          }
        )
      } else if (this.searchType === 2 ) {
        if(standardEfficiency[key] && value < standardEfficiency[key]) {
          data.push(
            {
              value: value.toFixed(2),
              itemStyle: {
                color: '#a90000'
              },
            }
          )
        } else {
          data.push(value.toFixed(2))
        }
      } else {
        data.push(value.toFixed(2))
      }
    })
    return data
  }

  mathDataLength(){
    return (90 / this.dataValue.length).toFixed(2)
  }

  init() {
    // console.log('dataValue:', this.dataValue)
    const xAxisData = []
    const seriesData = []
    const legendData = []
    this.columns.forEach(item => {
      xAxisData.push(item.title)
    });

    this.dataValue.forEach(res =>{
      this.standardEfficiency = res.standardEfficiency
      const seriesValue = {
        name: res.workStationName,
        type: 'bar',
        label: {
          show: true,
          position: 'top',
        },
        barWidth: (this.dataValue.length > 1) ? ( this.mathDataLength + '%') : '60%',
        data: this.seriesDataItem(res.data, this.standardEfficiency),
        markLine: this.standardEfficiency&&this.searchType===1 ? {
          silent: true,
          lineStyle: {
            normal: {
              color: 'red'                   // 这儿设置基准线颜色
            }
          },
          data: [{
            yAxis: this.standardEfficiency
          }],
          label: {
            normal: {
              formatter: '标准\n效率'           // 这儿设置基准线
            }
          },
        } : null,
      }
      legendData.push(res.workStationName)
      seriesData.push(seriesValue)
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart
    );
    // 指定图表的配置项和数据
    var option = {
      tooltip: {
        trigger: 'axis',
        // formatter: '{b}: {c}<br/>标准数值：' + this.standardEfficiency
        formatter: (val) => {
          if (this.searchType === 1) {
            // return val[0].name + '：' + val[0].value + '<br/>标准效率：' + this.standardEfficiency
            let standardEfficiency = this.standardEfficiency ? this.standardEfficiency : '--'
            return `${this.$t('page_workstation_statistical_efficiency')}：` + val[0].value + `<br/>${this.$t('page_workStation_standard_efficiency')}：` + standardEfficiency
          } else {
            let id = this.columns.find(item=>item.title===val[0].name).id
            let standardEfficiency1 = this.standardEfficiency[id] ? this.standardEfficiency[id] : '--'
            return `${this.$t('page_workstation_statistical_efficiency')}：` + val[0].value + `<br/>${this.$t('page_workStation_standard_efficiency')}：` + standardEfficiency1
          }
        },
      },
      legend: {
        show: (this.dataValue.length > 1),
        data: legendData,
        selectedMode: false
      },
      grid: {
        top: '30',
        left: '20',
        right: '40',
        bottom: '2%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0,
          rotate: -35,
          margin: 19,
          formatter: (val) => {
            var strs = val.split(''); //字符串数组
            var str = ''
            for(var i = 0, s; s = strs[i++];) { //遍历字符串数组
            str += s;
            if(!(i % 8)) str += '\n'; //按需要求余
            }
            return str
          },
        },
        axisLine: {onZero: true},
        data: xAxisData
      },
      /*visualMap: {
        show: false,
        pieces: [
          {
            gt: 0,
            lte: this.standardEfficiency,          //这儿设置基线上下颜色区分 基线下面为红色
            color: '#e91642'
          }, {
            gt: this.standardEfficiency,          //这儿设置基线上下颜色区分 基线上面为绿色
            color: '#03d6d6'
          }]
      },*/
      color: this.color,
      yAxis: [
        {
          type: 'value',
          boundaryGap: true,
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed'
            }
          },
          axisLabel:{
            formatter: value =>{
              return value + '%'
            }
          }
        }
      ],
      series: seriesData
    };
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option);
  }

  render() {
    return (
      <div ref="myChart" style={{width: (85 * (this.columns.length > 9 ? (this.columns.length * this.dataValue.length) : (10 * this.dataValue.length) )) + 'px', height: '300px'}}></div>
    )
  }
}
